import { useCallback, useEffect, useMemo, useState } from 'react';
import { callGearHandoff, activeReturnCustodySessions } from './gearHandoffApi';

const POLL_MS = 15000;

export default function useGearHandoffs(memberId) {
  const [sessions, setSessions] = useState([]);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    if (!memberId) return [];
    try {
      const payload = await callGearHandoff('list');
      const next = Array.isArray(payload?.sessions) ? payload.sessions : [];
      setSessions(next);
      setStatus('ready');
      setError('');
      return next;
    } catch (refreshError) {
      setStatus('error');
      setError(refreshError?.message || 'Unable to load gear handoffs.');
      return [];
    }
  }, [memberId]);

  useEffect(() => {
    if (!memberId) return undefined;
    refresh();
    const interval = window.setInterval(refresh, POLL_MS);
    const visible = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('online', refresh);
    document.addEventListener('visibilitychange', visible);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener('online', refresh);
      document.removeEventListener('visibilitychange', visible);
    };
  }, [memberId, refresh]);

  const activeReturnCustody = useMemo(() => activeReturnCustodySessions(sessions), [sessions]);
  const outgoing = useMemo(() => sessions.filter(session =>
    session?.outgoingUserId === memberId
    && ['pending', 'accepted'].includes(session?.status)
  ), [sessions, memberId]);

  return { sessions, activeReturnCustody, outgoing, status, error, refresh };
}
